import { Utag } from "../types";

const getUtag = (): Promise<Utag> => {
  if (typeof window === "undefined") {
    console.warn(
      "@argonaut/analytics function calls should be wrapped in a useEffect hook to prevent them running on the server",
    );
    return Promise.resolve({
      view: () => undefined,
      link: () => undefined,
      data: {},
    });
  }

  return new Promise((resolve) =>
    window["@argonaut/analytics/loadTealium"](() => resolve(window.utag)),
  );
};

export default getUtag;
